import AbstractDataAttributeBehaviour from "./abstract-data-attribute-behaviour";
import DataLayerManager from "../services/datalayer-manager";
export default class DatalayerBehaviour extends AbstractDataAttributeBehaviour {



    getContainerSelector(): null {
        return '[data-datalayer-push]'
    }

    initContainer(container) {
        let dataLayer = window.app.dataLayerManager;

        const name = container.getAttribute('data-datalayer-push');
        const data = JSON.parse(container.getAttribute('data-datalayer-context'));
        const config = JSON.parse(container.getAttribute('data-datalayer-config'));

        if(config.event){
            container.addEventListener(config.event, (e) => {
                dataLayer.push(name, data);
            });
        } else {
            dataLayer.push(name, data);
        }

    }
}